import mailStore from '../store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { trace } from 'owa-trace';
import { getFolderIdForSelectedNode, getSelectedNode } from 'owa-mail-folder-forest-store';
import isDeletedItemsFolderFromAnyMailbox from '../utils/isDeletedItemsFolderFromAnyMailbox';
function isLocalAvailableForSelectedNode() {
    var selectedNode = getSelectedNode();
    if (selectedNode.type == 2 /* Group */) {
        return true;
    }
    return !getFolderIdForSelectedNode();
}
/**
 * @returns [item to load based on selected folder, whether item is local, whether item is deleted].
 */
export function findItemToLoad(conversationNode) {
    var itemCount = conversationNode && conversationNode.itemIds ? conversationNode.itemIds.length : 0;
    if (itemCount == 0) {
        return [null, false, false];
    }
    var foundItem = null;
    // If selected folder doesn't exist, treat item as a local item.
    var isLocal = isLocalAvailableForSelectedNode();
    var isDeleted = false;
    if (itemCount == 1) {
        foundItem = mailStore.items.get(conversationNode.itemIds[0]);
        if (!checkIfItemExists(conversationNode.itemIds[0], foundItem)) {
            return [null, false, false];
        }
        isLocal =
            isLocal ||
                (foundItem.ParentFolderId &&
                    foundItem.ParentFolderId.Id == getFolderIdForSelectedNode());
    }
    else {
        var sentItem = null;
        for (var _i = 0, _a = conversationNode.itemIds; _i < _a.length; _i++) {
            var itemId = _a[_i];
            var item = mailStore.items.get(itemId);
            if (!checkIfItemExists(itemId, item)) {
                return [null, false, false];
            }
            if (item.ParentFolderId && item.ParentFolderId.Id == getFolderIdForSelectedNode()) {
                foundItem = item;
                isLocal = true;
                break;
            }
            else if (doesFolderIdEqualName(item.ParentFolderId.Id, 'sentitems')) {
                sentItem = item;
            }
        }
        if (!foundItem) {
            foundItem = sentItem || mailStore.items.get(conversationNode.itemIds[0]);
        }
    }
    isDeleted = isDeletedItemsFolderFromAnyMailbox(foundItem.ParentFolderId.Id);
    return [foundItem, isLocal, isDeleted];
}
function checkIfItemExists(itemId, item) {
    if (!itemId) {
        trace.error('ItemId in conversationNode.itemIds should not be:' + itemId);
        return false;
    }
    if (!item) {
        trace.error('Item should be in mailStore but does not exist.');
        return false;
    }
    return true;
}
export function shouldCreateItemPartViewState(item, isDeleted, isLocal) {
    var userConfiguration = getUserConfiguration();
    var shouldHideDeletedItems = userConfiguration.UserOptions.HideDeletedItems;
    // No need to create view state for deleted drafts except for delete folder.
    // No need to create view state for deleted items when user setting has HideDeletedItems except for delete folder.
    return item && !((item.IsDraft || shouldHideDeletedItems) && isDeleted && !isLocal);
}
export function getItemToShowFromNodeId(nodeId) {
    var conversationNode = mailStore.conversationNodes.get(nodeId);
    var _a = findItemToLoad(conversationNode), item = _a[0], isLocal = _a[1], isDeleted = _a[2];
    if (!shouldCreateItemPartViewState(item, isDeleted, isLocal)) {
        return null;
    }
    else {
        return item;
    }
}
//# sourceMappingURL=conversationsUtils.js.map